// src/hooks/useScrollReveal.js

import { useEffect, useRef, useState } from "react";
import "./styles.css";
// Hook theo dõi khi một phần tử xuất hiện trong viewport
const useScrollReveal = (options) => {
  // Lưu trữ tham chiếu (ref) đến DOM element
  const ref = useRef();
  // State để theo dõi phần tử có đang hiển thị không
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // entry.isIntersecting là true khi phần tử đi vào viewport
      if (entry.isIntersecting) {
        setIsVisible(true);
        // Ngừng theo dõi sau khi phần tử đã hiện ra (chỉ cần hiện 1 lần)
        observer.unobserve(entry.target);
      }
    }, options); // options thường bao gồm rootMargin và threshold

    if (ref.current) {
      observer.observe(ref.current);
    }

    // Cleanup function
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  // Trả về ref để gắn vào phần tử và state isVisible để kích hoạt CSS
  return [ref, isVisible];
};

export default useScrollReveal;
